<template>
  <div class="add-box">
    <el-form ref="form" :model="form" label-width="120px" class="user-form">
      <el-form-item label="bean名称:">
        <el-input v-model="form.beanName" placeholder="spring bean名称,如testTask" class="user-input" />
      </el-form-item>
      <el-form-item label="方法名称:">
        <el-input v-model="form.methodName" placeholder="方法名称" class="user-input" />
      </el-form-item>
      <el-form-item label="参数:">
        <el-input v-model="form.params" placeholder="参数" class="user-input" />
      </el-form-item>
      <el-form-item label="cron表达式:">
        <el-input v-model="form.cronExpression" placeholder="如：0 0 12 * * ?" class="user-input" maxlength="20" />
      </el-form-item>
      <el-form-item label="备注:">
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="4"
          placeholder="备注"
        />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click.prevent="submit">确定</el-button>
        <el-button type="warning" @click.prevent="back">返回</el-button>
      </el-form-item>
    </el-form>

  </div>
</template>

<script>
export default {
	    data() {
    return {
      form: {
        jobId: '',
        beanName: '',
        cronExpression: '',
        methodName: '',
        params: '',
        remark: ''
      }
    }
	    },

  created() {
    this.$emit('setCurrentMenu', '定时任务')
    this.getInfo()
  },

	    methods: {

    getInfo() {
      const vm = this
      const id = vm.$route.params.id
      vm.form.jobId = id
      vm.axios.get(this.homePath() + '/sys/schedule/info/' + id)
        .then(response => {
          const data = response.data
          console.log(data)
          if (data.status == '000000') {
            vm.form.beanName = data.schedule.beanName
            vm.form.cronExpression = data.schedule.cronExpression
            vm.form.methodName = data.schedule.methodName
            vm.form.params = data.schedule.params
            vm.form.remark = data.schedule.remark
            vm.form.status = data.schedule.status
          }
        })
        .catch(error => console.log(error))
    },

    submit() {
      let past = true
      if (this.form.beanName == '') {
        this.$alert('bean名称不能为空', '提示')
        past = false
      }
      if (this.form.cronExpression == '') {
        this.$alert('cron表达式不能为空', '提示')
        past = false
      }
      if (this.form.methodName == '') {
        this.$alert('方法名称不能为空', '提示')
        past = false
      }
      if (this.form.params == '') {
        this.$alert('参数不能为空', '提示')
        past = false
      }

      if (this.form.remark == '') {
        this.$alert('备注不能为空', '提示')
        past = false
      }

      if (past) {
        const vm = this
        vm.axios.post(this.homePath() + '/sys/schedule/update', vm.form)
          .then(response => {
            if (response.data.status == '000000') {
              this.$alert('修改成功', '提示', {
                callback: action => {
                  this.$router.push('/index/schedule')
                }
              })
            } else {
              this.$alert(response.data.message, '提示')
            }
          })
          .catch(error => console.log(error))
      }
    },

    back() {
      this.$router.push('/index/schedule')
    }
	    }
	  }
</script>

<style></style>

